export default "__VITE_ASSET__Cxc6krBh__"